
import { confirmAlert } from 'react-confirm-alert';
import "react-confirm-alert/src/react-confirm-alert.css";

const confirmChoiceAlert = (callback) => {
    confirmAlert({
        customUI: ({ onClose }) => {
            return (
                <div className='custom-ui'>
                    <div className='heading'>Are you sure?</div>
                    <div>
                        <button className='yes' onClick={
                            () => {
                                onClose()
                                if(callback) callback()
                            }
                        }>Yes,agree</button>
                        <button className='cancel' onClick={onClose}>No,cancel</button>
                    </div>
                </div>
            )
        },
        closeOnClickOutside: false
    });
}

export { confirmChoiceAlert }